import { ViewUser } from '../model/view-user.model';

export function groupUsers(
    signedInUser: ViewUser,
    favourites: ViewUser[],
    directReports: ViewUser[],
): ViewUser[] {
    const result: ViewUser[] = [signedInUser];
    result.push(
        ...[...favourites]
            .filter((e) => e.userId !== signedInUser.userId)
            .sort((a, b) => a.name.localeCompare(b.name)),
    );
    const fids = favourites.map((e) => e.userId);
    result.push(
        ...directReports
            .filter((e) => fids.includes(e.userId) !== true)
            .sort((a, b) => a.name.localeCompare(b.name)),
    );
    return result;
}
